import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles';
import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import Text, {
    TextDomTag,
} from 'client/widget-components/basicComponents/Text';
import { Asterisk } from 'client/widget-components/components/FieldLabel';
import {
    mergeResponsiveStyles,
    ResponsiveStylesProp,
} from 'client/widget-components/responsive-styles/responsiveStylesService';
import React, { ReactNode } from 'react';

interface BaseProductCustomizationLabelProps {
    label: string;
    required?: boolean;
    styles: ResponsiveStylesProp;
    dataAuto?: string;
    dataGrab?: string;
    children?: ReactNode;
}

// Label should inherit global H5 styles
const BaseProductCustomizationLabel = ({
    styles,
    label,
    required,
    dataAuto,
    dataGrab,
    children,
}: BaseProductCustomizationLabelProps) => (
    <Text tag={TextDomTag.h5} styles={labelWrapperDefaultStyles}>
        <Text
            tag={TextDomTag.span}
            styles={mergeResponsiveStyles([labelDefaultStyles, styles])}
            data-grab={dataGrab}
            data-auto={dataAuto}
        >
            {label}
            {required && <Asterisk>*</Asterisk>}
        </Text>
        {children}
    </Text>
);

const labelWrapperDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: 0,
        width: '100%',
        direction: 'inherit',
    },
};

const labelDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        margin: 0,
        width: '100%',
    },
};

export default BaseProductCustomizationLabel;
